module.exports = __webpack_public_path__ + "media/2x/areas-of-study@2x-4ae6808c.png";